import { css } from "@emotion/react";
import styled from "@emotion/styled";
import * as React from "react";

import { DesignToken, ShadowToken } from "@livechat/design-system-react-components";

import { StatelessPopperContainer } from "components/popper-container";
import { withVar } from "themes/helpers";

import { CustomerDetailsContext } from "./CustomerDetailsContext";

const TooltipContent = styled.div`
  background-color: ${withVar(DesignToken.SurfaceInvertPrimary)};
  border-color: ${withVar(DesignToken.BorderBasicContrast)};
  border-radius: 4px;
  box-sizing: border-box;
  box-shadow: ${withVar(ShadowToken.Tooltip)};
  color: ${withVar(DesignToken.ContentInvertPrimary)};
  font-size: 14px;
  line-height: 18px;
  max-width: 260px;
  padding: 8px 10px;
  word-break: break-all;
`;

const arrowCss = css`
  .popper-arrow {
    position: absolute;
    height: 8px;
    margin: 0 4px;
    width: 16px;

    &:after {
      background: ${withVar(DesignToken.SurfaceInvertPrimary)};
      content: "";
      height: 8px;
      left: 50%;
      position: absolute;
      transform: translate(-50%, -50%) rotate(45deg);
      width: 8px;
      z-index: 1;
    }
  }

  .popper-popup[x-placement^="top"] .popper-arrow {
    top: 100%;
  }
`;

interface ITooltipProps {
  isVisible: boolean;
  tooltipContent: React.ReactNode;
  children: React.ReactNode;
}
/**
 * @deprecated - use DS' Popover instead
 */
export class CustomerDetailsTooltip extends React.PureComponent<ITooltipProps> {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private get content() {
    return <TooltipContent>{this.props.tooltipContent}</TooltipContent>;
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    return (
      <CustomerDetailsContext.Consumer>
        {({ contentRef }) => (
          <StatelessPopperContainer
            arrowCss={arrowCss}
            // @ts-expect-error TS(2322)
            boundariesElement={contentRef ? contentRef.current : "viewport"}
            childrenZIndex="inherit"
            content={this.content}
            contentZIndex={2100}
            contentPosition="absolute"
            isVisible={this.props.isVisible}
            offset="0, 10"
            placement="top-start"
            preventOverflow={false}
          >
            {this.props.children}
          </StatelessPopperContainer>
        )}
      </CustomerDetailsContext.Consumer>
    );
  }
}
